import React from 'react'
import { Box, Text } from '@chakra-ui/react'

export function StatusPill({ label }: { label: string }) {
  return (
    <Box
      as="span"
      display="inline-flex"
      alignItems="center"
      px={3}
      py={1}
      borderRadius="999px"
      bg="gray.100"
      color="gray.800"
      fontWeight={700}
      fontSize="xs"
    >
      <Text>{label}</Text>
    </Box>
  )
}
